import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {$insertNodeToNearestRoot} from '@lexical/utils';
import {$createAuraVideoNode, AuraVideoNode} from 'components/DSYS/editor/nodes/AuraVideoNode';
import {COMMAND_PRIORITY_EDITOR, createCommand, LexicalCommand} from 'lexical';
import {useEffect} from 'react';

export type InsertAuraVideoPayload = Readonly<{videoRef: string; origin?: string}>;

export const INSERT_AURA_VIDEO_COMMAND: LexicalCommand<InsertAuraVideoPayload> = createCommand(
  'INSERT_AURA_VIDEO_COMMAND'
);

export const AuraVideoPlugin = () => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    if (!editor.hasNodes([AuraVideoNode])) {
      throw new Error('AuraVideoPlugin: AuraVideoNode not registered on editor');
    }

    return editor.registerCommand<InsertAuraVideoPayload>(
      INSERT_AURA_VIDEO_COMMAND,
      ({videoRef, origin}) => {
        const node = $createAuraVideoNode(videoRef, origin);
        $insertNodeToNearestRoot(node);
        return true;
      },
      COMMAND_PRIORITY_EDITOR
    );
  }, [editor]);

  return null;
};
